module.exports = __webpack_public_path__ + "images/pages/lp/pattern_bg_ball_pale_orange_fa9cf61a664024794e2765eb84fccbf1.png";